import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getItemHistory } from '../Api'

export default generateApiAction({
  baseType: Types.ITEMS.GET.HISTORY,
  api: getItemHistory,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/items/GetHistoryAction.js